export default __webpack_public_path__ + "90f46304173bfa1f74552ec230cc99d5.mp3";